// import type { FormState } from '@tanstack/react-form';
// import type { Store } from '@tanstack/store';

import { useEffect, useState } from 'react';

// TODO: implement type magic here

export function useFormTouched<T>(
    store: any, // Store<FormState<T>>,
    defaultValues: T,
) {
    const [isEmpty, setIsEmpty] = useState<boolean>(true);

    useEffect(() => {
        return store.subscribe(() => {
            if (store.state.isPristine !== isEmpty) {
                setIsEmpty(store.state.isPristine);
            }

            if (JSON.stringify(store.state.values) === JSON.stringify(defaultValues)) {
                setIsEmpty(true);
            }
        });
    }, [store, isEmpty, defaultValues]);

    return !isEmpty;
}

//
